import { render, staticRenderFns } from "./RegularUseVehicleSelect.vue?vue&type=template&id=be23022e&lang=pug"
import script from "./RegularUseVehicleSelect.vue?vue&type=script&lang=js"
export * from "./RegularUseVehicleSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports